(ns ui.view.list-opensearch.model)

(def root-path [::state])

(def config-key :config)
(def compiled-config-key :compiled-config)
(def items-key :items)
(def status-key :status)
(def error-key :error)
(def total-key :total)
(def next-offset-key :next-offset)
(def has-more-key :has-more?)
;; Grouped mode (list/gallery group-by)
(def groups-key :groups)
(def items-by-group-key :items-by-group)

(defn list-path
  [list-id]
  (into root-path [list-id]))

(defn config-path
  [list-id]
  (into root-path [list-id config-key]))

(defn compiled-config-path
  [list-id]
  (into root-path [list-id compiled-config-key]))

(defn groups-path
  [list-id]
  (into root-path [list-id groups-key]))

(defn items-by-group-path
  [list-id]
  (into root-path [list-id items-by-group-key]))
